(function(){
  try{
    var u=new URLSearchParams(window.location.search);
    if(u.get('customer_posted')==='true'){
      var shown=document.querySelector('[data-dl].show');
      if(!shown){var d=document.querySelector('[data-dl]');if(d){d.classList.add('show');shown=d;}}
      if(shown){setTimeout(function(){shown.scrollIntoView({behavior:'smooth',block:'center'});},300);}
    }
  }catch(e){}
})();
